"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableClaims = void 0;
exports.availableClaims = [
    {
        id: '0',
        claimType: 'full',
        name: 'Full Control',
        description: 'Provides the user with full control over both the Hub and App',
        appliesTo: ['org'],
    },
    {
        id: '1',
        claimType: 'createItinerary',
        name: 'Create Itinerary',
        description: 'Allows the user to create a new  itinerary in App and in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '2',
        claimType: 'editItinerary',
        name: 'Edit Itinerary',
        description: 'Allows the user to edit itinerary and sections in App and the Hub',
        appliesTo: ['org', 'itin', 'section', 'itinTag'],
    },
    {
        id: '3',
        claimType: 'deleteItinerary',
        name: 'Delete Itinerary',
        description: 'Allows the user to delete an itinerary in App and the Hub',
        appliesTo: ['org', 'itin'],
    },
    {
        id: '4',
        claimType: 'createUser',
        name: 'Create User',
        description: 'Allows the user to create a user in App(edit Itinerary members and team page) and the Hub',
        appliesTo: ['org'],
    },
    {
        id: '5',
        claimType: 'editUser',
        name: 'Edit User',
        description: 'Allows the user to edit a user in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '6',
        claimType: 'deleteUser',
        name: 'Delete User',
        description: 'Allows the user to delete a user in App(Edit Itinerary members page) and the Hub',
        appliesTo: ['org'],
    },
    {
        id: '7',
        claimType: 'modifyClaims',
        name: 'Modify Claims',
        description: 'Allows the user to access and modify team permissions in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '8',
        claimType: 'accessHub',
        name: 'Access Coordinator Hub',
        description: 'Allows the user to access the Hub with limited functionality',
        appliesTo: ['org'],
    },
    {
        id: '9',
        claimType: 'chatAccess',
        name: 'Chat Access',
        description: 'Allows the user to access the chat features in the App',
        appliesTo: ['org'],
    },
    {
        id: '10',
        claimType: 'viewTeamPage',
        name: 'Team Page Access',
        description: 'Allows the user to access the team page in the App',
        appliesTo: ['org'],
    },
    {
        id: '11',
        claimType: 'editCostings',
        name: 'Add or Edit Costs',
        description: 'Allows the user to add and edit sections costs and edit costings page in the Hub"',
        appliesTo: ['org'],
    },
    {
        id: '12',
        claimType: 'viewCostings',
        name: 'View Costings',
        description: 'Allows the user to view costs and budgets in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '13',
        claimType: 'guestMode',
        name: 'Add Guests',
        description: 'Allows assigning of guest role to users in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '14',
        claimType: 'generatePDF',
        name: 'Generate PDFs',
        description: 'Generate PDFs of your itineraries and reports in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '15',
        claimType: 'theme',
        name: 'Add Theme',
        description: 'Allows setting of custom themes for the App in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '16',
        claimType: 'settingsPage',
        name: 'Settings Page',
        description: 'Allows the user access to the settings page in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '17',
        claimType: 'plannerPage',
        name: 'Planner Page',
        description: 'Allows the user access to the planner page in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '18',
        claimType: 'itineraryTagAdmin',
        name: 'Itinerary Tags',
        description: 'Allows the user to create, edit and delete itinerary groups/tags in the Hub',
        appliesTo: ['org'],
    },
    {
        id: '19',
        claimType: 'userPrivateInfoViewer',
        name: 'View users private Information',
        description: 'Allows user to view other users private information in the App',
        appliesTo: ['org'],
    },
    {
        id: '20',
        claimType: 'manageGroupChat',
        name: 'Managing Group Chats',
        description: 'Allows the user to create team group chats in the App',
        appliesTo: ['org'],
    },
    {
        id: '21',
        claimType: 'deleteGroupChat',
        name: 'Delete Group Chats',
        description: 'Allows users to delete team group chats in the App',
        appliesTo: ['org'],
    },
];
